import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import 'leaflet-lasso';
import * as L from 'leaflet';
import { BehaviorSubject } from 'rxjs';
import { EditableMapService } from '@map/services/editable-map.service';

@Component({
    selector: 'app-draw-transform-control',
    templateUrl: 'transform.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DrawTransformComponent {
    @Input()
    map: L.Map;

    @Input()
    transformSettings: {
        union: boolean;
    } = {
        union: true,
    };

    constructor(private editableMapService: EditableMapService) {}

    union() {
        this.editableMapService.union();
    }
}
